import { render, staticRenderFns } from "./CalendarGrid.vue?vue&type=template&id=5236852b"
import script from "./CalendarGrid.vue?vue&type=script&lang=ts"
export * from "./CalendarGrid.vue?vue&type=script&lang=ts"
import style0 from "./CalendarGrid.vue?vue&type=style&index=0&id=5236852b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports